export default "<div class=\"footer text-center\">\n  <div [ngClass]=\"setModelColor()\">\n    <p class=\"txt\">{{getModel()}} Modell</p>\n  </div>\n</div>\n"